<template>
  <div>
    <WmsTable
      rowKey="exceptionCode"
      :columns="columns"
      :dataSource="dataSource"
      :isPagination="query"
      :hasHeader="false"
      @pageChange="pageChangeCall"
    >
      <div slot="pics" slot-scope="{ record }" class="pic-cell">
        <el-image
          v-if="record.pics && record.pics.length"
          :src="record.pics[0]"
          :preview-src-list="record.pics"
          style="width: 46px; height: 46px"
        />
        <span v-if="record.pics && record.pics.length" class="pic-badge">{{ record.pics.length }}</span>
      </div>
      <div slot="action" slot-scope="{ record }">
        <el-button type="text" @click="$emit('edit', record)">编辑</el-button>
        <el-button v-if="!isReplied(record)" type="text" style="color: #d44" @click="$emit('remove', record)">删除</el-button>
        <el-button type="text" @click="$emit('reply', record)">{{ isReplied(record) ? "修改回复" : "填写回复" }}</el-button>
        <el-button type="text" @click="$emit('log', record)">操作日志</el-button>
      </div>
    </WmsTable>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import { EXCEPTION_STATUS, getColumns } from "../data";

export default {
  name: "InterList",
  components: {
    WmsTable,
  },
  props: {
    // 列表数据
    dataSource: {
      type: Array,
      default: () => [],
    },
    // 总条数
    total: {
      type: [Number, String],
      default: 0,
    },
    // 当前异常类型
    exceptionType: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      // 分页对象
      query: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
    };
  },
  computed: {
    // 当前 Tab 列配置
    columns: function () {
      return getColumns(this.exceptionType);
    },
  },
  watch: {
    total: {
      immediate: true,
      handler: function (val) {
        this.query.total = val || 0;
      },
    },
  },
  methods: {
    // 是否已回复
    isReplied: function (record) {
      return Number(record && record.status) === EXCEPTION_STATUS.REPLIED;
    },
    // 分页变化回传父组件
    pageChangeCall: function (payload) {
      this.query.current = payload.current;
      this.query.pageSize = payload.pageSize;
      this.$emit("pageChange", payload);
    },
    // 查询后重置页码
    resetPage: function () {
      this.query.current = 1;
    },
  },
};
</script>

<style scoped>
.pic-cell {
  position: relative;
  display: inline-block;
}

.pic-badge {
  position: absolute;
  right: -8px;
  bottom: -5px;
  background: #f5222d;
  color: #fff;
  border-radius: 14px;
  padding: 2px 6px;
  font-size: 11px;
  line-height: 1.2;
}
</style>
